(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-customer-reviews-list"]) return;
  try {
    
  function initCustomerReviewsList(root) {
    if (!root || root.dataset.reviewsListReady === 'true') return;

    const items = Array.from(root.querySelectorAll('[data-review-item]'));
    const filterButtons = Array.from(root.querySelectorAll('[data-review-filter]'));
    const pagination = root.querySelector('[data-review-pagination]');
    const previousButton = pagination?.querySelector('.prev');
    const nextButton = pagination?.querySelector('.next');
    const pageStatus = root.querySelector('[data-review-page-status]');
    const perPage = Math.max(1, Number.parseInt(root.dataset.reviewsPerPage, 10) || 3);
    let activeFilter = 'all';
    let currentPage = 1;

    function filteredItems() {
      if (activeFilter === 'all') return items;
      const token = `|${activeFilter}|`;
      return items.filter((item) => item.dataset.reviewBenefits.includes(token));
    }

    function render() {
      const visibleItems = filteredItems();
      const totalPages = Math.max(1, Math.ceil(visibleItems.length / perPage));
      currentPage = Math.min(currentPage, totalPages);
      const startIndex = (currentPage - 1) * perPage;
      const pageItems = new Set(visibleItems.slice(startIndex, startIndex + perPage));

      items.forEach((item) => {
        item.hidden = !pageItems.has(item);
      });

      filterButtons.forEach((button) => {
        const isActive = button.dataset.reviewFilter === activeFilter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (pagination) pagination.hidden = visibleItems.length <= perPage;
      if (previousButton) previousButton.disabled = currentPage <= 1;
      if (nextButton) nextButton.disabled = currentPage >= totalPages;
      if (pageStatus) pageStatus.textContent = `${currentPage} / ${totalPages}`;
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.reviewFilter;
        currentPage = 1;
        render();
      });
    });

    previousButton?.addEventListener('click', () => {
      currentPage -= 1;
      render();
    });

    nextButton?.addEventListener('click', () => {
      currentPage += 1;
      render();
    });

    root.revealReviewItem = (item) => {
      activeFilter = 'all';
      currentPage = Math.floor(items.indexOf(item) / perPage) + 1;
      render();
    };

    root.dataset.reviewsListReady = 'true';
    render();
  }

  function initCustomerReviewsLists(scope = document) {
    scope.querySelectorAll('.customer-reviews-list[data-reviews-per-page]').forEach(initCustomerReviewsList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCustomerReviewsLists());
  } else {
    initCustomerReviewsLists();
  }

  document.addEventListener('shopify:section:load', (event) => initCustomerReviewsLists(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('[data-review-item]');
    const root = item?.closest('.customer-reviews-list');
    if (item && root?.revealReviewItem) root.revealReviewItem(item);
  });

  } catch(e) { console.error(e); }
})();
})();
